import { FC } from 'react';
import { Button } from '@new/common/ui';
import type { ScheduledCall } from '@teachur/http-client';
import { LockedChip } from '@new/common/ui/Chip/LockedChip';
import type { CourseHearingReviewStatus } from '@new/features/courses/utils/hearingHelpers';
import { ScheduleStatusMessage } from './ScheduleStatusMessage';
import { HearingStatusMessage } from './HearingStatusMessage';
import { StepMessage } from '../StepMessage';

interface HearingOverviewProps {
  isLocked: boolean;
  canScheduleMeeting: boolean;
  scheduledCallStatus?: ScheduledCall['status'];
  hearingStatus: CourseHearingReviewStatus;
  showScheduleMessage: boolean;
  isMissed?: boolean;
  onScheduleClick: () => void;
}

export const HearingOverview: FC<HearingOverviewProps> = ({
  isLocked,
  canScheduleMeeting,
  scheduledCallStatus,
  hearingStatus,
  showScheduleMessage,
  isMissed,
  onScheduleClick,
}) => {
  return (
    <div className="flex flex-col gap-6 rounded-2xl border-2 border-(--neutral-black-NB200) bg-[#FAFDFF] p-6 lg:p-8">
      <div className="flex flex-col gap-3">
        {isLocked && (
          <StepMessage
            variant="warning"
            message="You need to complete the Course Project first. Submit your project and wait for your instructor to approve it before unlocking the Course Hearing."
          />
        )}
        <div className="flex items-center justify-start gap-2">
          <h4 className="[font-size:var(--fs-h6)]! lg:[font-size:var(--fs-h4)]! text-(--neutral-black-NB1000)! font-bold m-0!">
            Course Hearing
          </h4>
          {isLocked && <LockedChip />}
        </div>

        <div className="h-[1.5px] bg-(--neutral-black-NB200)" />

        <div className="flex flex-col lg:flex-row justify-between gap-6">
          <div className="flex flex-1 flex-col gap-4">
            <p className="[font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! text-(--neutral-black-NB900) leading-[150%] m-0!">
              Select a time from the available slots to request your Course Hearing.
            </p>
            {showScheduleMessage && (
              <ScheduleStatusMessage status={scheduledCallStatus} isMissed={isMissed} />
            )}
            {hearingStatus && <HearingStatusMessage status={hearingStatus} />}
          </div>

          {canScheduleMeeting && (
            <Button variant="outline" onClick={onScheduleClick}>
              Schedule Meeting
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
